import React, { useEffect, useState } from "react";
import api from "../../api";
import { Pagination, Stack } from "@mui/material";
import { Loader } from "./loader";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import "./AdminDashboard.css"; // Import CSS file

function AdminSupportTicket({ adminType }) {
  const adminStore = useSelector((state) => state.adminReducer);
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(50);
  const [data, setData] = useState([]);
  const [noTicket, setNoTicket] = useState(0);
  const [loader, setLoader] = useState(true);
  const [inputData, setInputData] = useState({});
  const [resetPage, setResetPage] = useState(false);
  const [firstRender, setfirstRender] = useState(false);
  const [searchMail, setSearchMail] = useState("");
  const [supportMembers, setsupportMembers] = useState([]);
  const [initialLoaded, setInitialLoaded] = useState(false);
  const [stats, setStats] = useState({
    pending: 0,
    processing: 0,
    closed: 0,
    total: 0,
  });
  const [selectedIds, setSelectedIds] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("");

  const getTickets = async (p, filters) => {
    try {
      setfirstRender(true);
      const payload = { page: p, ...filters };
      setLoader(true);
      const userData = await api.adminAllTicketGet(payload);
      setData(userData.tickets);
      setNoTicket(userData.count);
      setLimit(userData.limit);

      // Calculate stats from data
      const pendingCount = userData.tickets.filter(
        (t) => t?.status === "pending",
      ).length;
      const processingCount = userData.tickets.filter(
        (t) => t?.status === "processing",
      ).length;
      const closedCount = userData.tickets.filter(
        (t) => t?.status === "closed",
      ).length;

      setStats({
        pending: pendingCount,
        processing: processingCount,
        closed: closedCount,
        total: userData.count,
      });

      setLoader(false);
    } catch (error) {
      console.log(error?.message);
      setLoader(false);
    }
  };

  useEffect(() => {
    const qs = window.location.search;

    if (qs) {
      const obj = queryStringToObject(qs);
      const p = obj.page ? Number(obj.page) : 1;
      delete obj.page;

      setPage(p);
      setInputData(obj);
      setInitialLoaded(true);
    } else {
      setInitialLoaded(true);
      getTickets(1, inputData);
    }
  }, []);

  useEffect(() => {
    if (!initialLoaded) return;

    const appliedFilters = { ...inputData, page };

    // update URL
    const qs = objectToQueryString(appliedFilters);
    navigate(`/admin/support?${qs}`, { replace: true });

    // fetch
    getTickets(page, inputData);
  }, [page, inputData, initialLoaded]);

  const searchFilter = () => {
    if (page == 1) {
      getTickets();
    } else {
      setPage(1);
    }
  };

  const handleReset = () => {
    setInputData({});
    setSearchMail("");
    setResetPage(!resetPage);
    setPage(1);
    navigate("/admin/support");
  };

  const handleSearch = async () => {
    if (searchMail) {
      let payload = {
        email: searchMail,
      };
      const res = await api.adminSearchTicket(payload);
      if (res?.success) {
        setData(res?.tickets);
        setNoTicket(res?.tickets?.length || 0);
      } else {
        alert("Invalid Email Address");
      }
    } else {
      alert("Please insert email for search");
    }
  };

  const getSupport = async () => {
    try {
      setLoader(true);
      const res = await api.getSupportAdmin();
      if (res?.success) {
        setsupportMembers(res.support);
      }
      setLoader(false);
    } catch (error) {
      console.log(error?.message);
      setLoader(false);
    }
  };

  useEffect(() => {
    getSupport();
  }, []);

  const queryStringToObject = (url) =>
    Object.fromEntries([...new URLSearchParams(url.split("?")[1])]);

  const objectToQueryString = (dataObject) => {
    let queryString = Object.keys(dataObject)
      .map((key) => {
        if (Array.isArray(dataObject[key])) {
          return dataObject[key]
            .map((item, index) => {
              return (
                encodeURIComponent(key) +
                "[" +
                index +
                "]=" +
                encodeURIComponent(item)
              );
            })
            .join("&");
        } else {
          return (
            encodeURIComponent(key) + "=" + encodeURIComponent(dataObject[key])
          );
        }
      })
      .join("&");
    return queryString;
  };

  // bulk edit status
  const editBulkTicketStatus = async (status) => {
    try {
      if (!status) {
        return;
      }
      if (selectedIds.length === 0) {
        alert("Select atleast one ticket");
        return;
      }
      console.log(selectedIds);
      setLoader(true);
      let payload = {
        status,
        ids: selectedIds,
      };
      const response = await api.adminBulkEditTicket(payload);
      // console.log(response);
      if (response?.success) {
        getTickets(page, inputData);
        setSelectedStatus("");
        setSelectedIds([]);
      }
      setLoader(false);
    } catch (error) {
      console.log(error.message);

      alert.show(error.message || "Something went wrong.");
      setLoader(false);
    }
  };

  const handleSelect = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id],
    );
  };
  const handleSelectAll = () => {
    if (selectedIds.length === data.length) {
      setSelectedIds([]);
    } else {
      setSelectedIds(data.map((item) => item.issueId));
    }
  };

  return (
    <>
      <div className="container-fluid admin-dashboard support-tickets-page">
        {/* Stats Cards */}
        <div className="row stats-overview mb-4">
          <div className="col-xl-3 col-md-6 mb-4">
            <div className="stat-card primary-gradient">
              <div className="stat-icon">
                <i className="fas fa-ticket-alt"></i>
              </div>
              <div className="stat-content">
                <div className="stat-value">{stats.total}</div>
                <div className="stat-label1">Total Tickets</div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-md-6 mb-4">
            <div className="stat-card warning-gradient">
              <div className="stat-icon">
                <i className="fas fa-clock"></i>
              </div>
              <div className="stat-content">
                <div className="stat-value">{stats.pending}</div>
                <div className="stat-label1">Pending</div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-md-6 mb-4">
            <div className="stat-card info-gradient">
              <div className="stat-icon">
                <i className="fas fa-spinner"></i>
              </div>
              <div className="stat-content">
                <div className="stat-value">{stats.processing}</div>
                <div className="stat-label1">Processing</div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-md-6 mb-4">
            <div className="stat-card success-gradient">
              <div className="stat-icon">
                <i className="fas fa-check-circle"></i>
              </div>
              <div className="stat-content">
                <div className="stat-value">{stats.closed}</div>
                <div className="stat-label1">Closed</div>
              </div>
            </div>
          </div>
        </div>

        {/* Page Header */}
        <div className="row page-header mb-4">
          <div className="col-12">
            <div className="page-header-card">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h1 className="page-title">Support Tickets</h1>
                  <p className="page-subtitle">
                    Manage and monitor all customer support tickets
                  </p>
                </div>
                <div className="header-actions">
                  <button
                    className="btn-action refresh-btn"
                    onClick={() => getTickets(page, inputData)}
                    title="Refresh"
                  >
                    <i className="fas fa-sync-alt"></i> Refresh
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Filter Section */}
        <div className="row filter-section mb-4">
          <div className="col-12">
            <div className="filter-card">
              <div className="filter-header">
                <div className="filter-label">
                  <i className="fas fa-filter"></i> Filter Tickets
                </div>
              </div>
              <div className="filter-body">
                <div className="row g-3">
                  <div className="col-md-3">
                    <div className="filter-group">
                      <label className="filter-label-small">Issue Type</label>
                      <div className="select-wrapper">
                        <i className="fas fa-caret-down select-arrow"></i>
                        <select
                          name="issueType"
                          onChange={(e) =>
                            setInputData({
                              ...inputData,
                              issueType: e.target.value,
                            })
                          }
                          value={inputData?.issueType}
                          className="filter-select"
                        >
                          <option value="">Select Issue</option>
                          <option value="Account Issue">Account Issue</option>
                          <option value="Payment Issue">Payment Issue</option>
                          <option value="Technical Issue">
                            Technical Issue
                          </option>
                          <option value="Mexc Telegram Group">
                            Mexc Telegram Group
                          </option>
                          <option value="Welcome Paid Email Issue">
                            Welcome Paid Email Issue
                          </option>
                          <option value="OTP Issues">OTP Issues</option>
                          <option value="Forgot Password Issues">
                            Forgot Password Issues
                          </option>
                          <option value="Other">Other</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="filter-group">
                      <label className="filter-label-small">Status</label>
                      <div className="select-wrapper">
                        <i className="fas fa-caret-down select-arrow"></i>
                        <select
                          name="status"
                          onChange={(e) =>
                            setInputData({
                              ...inputData,
                              status: e.target.value,
                            })
                          }
                          value={inputData?.status}
                          className="filter-select"
                        >
                          <option value="">Select Status</option>
                          <option value="pending">Pending</option>
                          <option value="processing">Processing</option>
                          <option value="closed">Closed</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  {(adminStore?.admin?.admin?.email == "alex@waqarzaka.net" ||
                    adminStore?.admin?.admin?.email ==
                      "malaika@waqarzaka.net" ||
                    adminStore?.admin?.admin?.email == "mike@waqarzaka.net" ||
                    adminType == "mackAdmin777") && (
                    <div className="col-md-3">
                      <div className="filter-group">
                        <label className="filter-label-small">
                          Support Member
                        </label>
                        <div className="select-wrapper">
                          <i className="fas fa-caret-down select-arrow"></i>
                          <select
                            name="support"
                            onChange={(e) =>
                              setInputData({
                                ...inputData,
                                supportId: e.target.value,
                              })
                            }
                            value={inputData?.supportId}
                            className="filter-select"
                          >
                            <option value="">Select Support</option>
                            {supportMembers.map((val, key) => (
                              <option key={key} value={val?._id}>
                                {val?.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="col-md-3">
                    <div className="filter-group">
                      <label className="filter-label-small">
                        Search by Email
                      </label>
                      <div className="support-search-input-group">
                        <input
                          type="text"
                          placeholder="Search by email..."
                          value={searchMail}
                          onChange={(e) => setSearchMail(e.target.value)}
                          className="support-search-input"
                          onKeyPress={(e) =>
                            e.key === "Enter" && handleSearch()
                          }
                        />
                        <button
                          className="support-search-btn"
                          onClick={handleSearch}
                        >
                          <i className="fas fa-search"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="filter-actions mt-3">
                  <button
                    className="themeBlackBtn"
                    onClick={() => handleReset()}
                  >
                    <i className="fas fa-redo"></i> Reset Filters
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Main Table */}
        <div className="row">
          <div className="col">
            <Table
              data={data}
              setPage={setPage}
              page={page}
              noTicket={noTicket}
              limit={limit}
              handleSelectAll={handleSelectAll}
              selectedIds={selectedIds}
              handleSelect={handleSelect}
              editBulkTicketStatus={editBulkTicketStatus}
              selectedStatus={selectedStatus}
              setSelectedStatus={setSelectedStatus}
            />
          </div>
        </div>
      </div>

      {loader && <Loader />}
    </>
  );
}

const Table = ({
  data,
  page,
  setPage,
  noTicket,
  limit,
  handleSelectAll,
  selectedIds,
  handleSelect,
  editBulkTicketStatus,
  selectedStatus,
  setSelectedStatus,
}) => {
  const [activeImg, setActiveImg] = useState("");
  const [showMore, setShowMore] = useState(false);
  const handleCloseMore = () => setShowMore(false);
  const handleShowMore = () => setShowMore(true);
  const navigate = useNavigate();

  const handleChange = (event, value) => {
    setPage(value);
  };

  const formatDate = (date) => {
    let dateTemp = moment(date).format("MMMM Do YYYY, h:mm:ss a");
    return dateTemp;
  };

  const handleActiveImg = (link) => {
    setActiveImg(link);
    handleShowMore();
  };

  return (
    <>
      <div className="card modern-table-card">
        <div className="table-header-section">
          <div className="table-title-group flex-wrap p-3">
            <div className="d-flex flex-wrap ai-center">
              <h3 className="table-title">All Support Tickets</h3>
              <div className="select-wrapper ms-2">
                <i className="fas fa-caret-down select-arrow"></i>
                <select
                  onChange={(e) => setSelectedStatus(e.target.value)}
                  defaultValue={selectedStatus}
                  className="filter-select"
                >
                  <option
                    value="pending"
                    selected={selectedStatus == "pending" ? true : false}
                  >
                    Pending
                  </option>
                  <option
                    value="processing"
                    selected={selectedStatus == "processing" ? true : false}
                  >
                    Processing
                  </option>
                  <option
                    value="closed"
                    selected={selectedStatus == "closed" ? true : false}
                  >
                    Closed
                  </option>
                </select>
              </div>
              <button
                className="themeBlackBtn ms-2 jc-center"
                onClick={() => editBulkTicketStatus(selectedStatus)}
              >
                Submit
              </button>
            </div>
            <span className="table-subtitle ms-auto">
              {noTicket} tickets found
            </span>
          </div>
        </div>

        <div className="table-responsive">
          <table className="table modern-table tickets-table">
            <thead className="table-header">
              <tr>
                <th className="table-head-cell">Issue ID</th>
                <th className="table-head-cell">Image</th>
                <th className="table-head-cell">User Email</th>
                <th className="table-head-cell">
                  <input
                    type="checkbox"
                    onChange={handleSelectAll}
                    checked={
                      selectedIds.length === data.length && data.length > 0
                    }
                    className="me-2"
                  />
                  Status
                </th>
                <th className="table-head-cell">Issue Type</th>
                <th className="table-head-cell">Created At</th>
                <th className="table-head-cell">Processed By</th>
                <th className="table-head-cell">Closed By</th>
                <th className="table-head-cell">Expected to close</th>
                <th className="table-head-cell">View</th>
              </tr>
            </thead>
            <tbody className="table-body">
              {data.map((item, key) => (
                <tr key={key} className="table-row">
                  <td className="table-cell">
                    <div className="issue-id">{item?.issueId}</div>
                  </td>
                  <td className="table-cell">
                    {item?.imageTitle ? (
                      <div
                        className="ticket-image"
                        onClick={() =>
                          handleActiveImg(
                            `${process.env.REACT_APP_S3URL}/img_${item?.imageTitle}.${item.imageFormat}`,
                          )
                        }
                      >
                        <img
                          src={`${process.env.REACT_APP_S3URL}/img_${item?.imageTitle}.${item.imageFormat}`}
                          alt="Ticket attachment"
                          className="img-preview"
                        />
                        <div className="image-overlay">
                          <i className="fas fa-expand"></i>
                        </div>
                      </div>
                    ) : (
                      <div className="no-image">-</div>
                    )}
                  </td>
                  <td className="table-cell">
                    <div className="user-email">{item?.userId?.email}</div>
                  </td>
                  <td className="table-cell">
                    <div className="d-flex">
                      <input
                        type="checkbox"
                        checked={selectedIds.includes(item.issueId)}
                        onChange={() => handleSelect(item.issueId)}
                        className="me-2"
                      />
                      <div className={`status-badge status-${item?.status}`}>
                        {item?.status}
                      </div>
                    </div>
                  </td>
                  <td className="table-cell">
                    <div className="issue-type">{item?.issueType}</div>
                  </td>
                  <td className="table-cell">
                    <div className="created-at">
                      {formatDate(item?.createdAt)}
                    </div>
                  </td>
                  <td className="table-cell">
                    <div className="processed-by">
                      {item?.processedBy?.name || "-"}
                    </div>
                  </td>
                  <td className="table-cell">
                    <div className="closed-by">
                      {item?.closedBy?.name || "-"}
                    </div>
                  </td>
                  <td className="table-cell">
                    <div className="expected-close">
                      {item?.latestUserMessageSeen === false && (
                        <div
                          className="unread-message-indicator"
                          title="Unread message"
                        >
                          <i className="fas fa-envelope"></i>
                        </div>
                      )}
                      {item?.status == "processing" &&
                      item?.processingStartedAt ? (
                        <TicketTimer
                          processingStartedAt={item?.processingStartedAt}
                        />
                      ) : (
                        "-"
                      )}
                    </div>
                  </td>
                  <td className="table-cell">
                    <button
                      className="view-btn"
                      onClick={() =>
                        navigate(`/admin/support/ticket/${item?.issueId}`)
                      }
                      title="View Ticket Details"
                    >
                      <i className="fas fa-eye"></i>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {data.length === 0 && (
          <div className="empty-table-state">
            <div className="empty-state-content">
              <i className="fas fa-ticket-alt empty-state-icon"></i>
              <h4 className="empty-state-title">No tickets found</h4>
              <p className="empty-state-description">
                There are no support tickets matching your criteria.
              </p>
            </div>
          </div>
        )}

        {data.length > 0 && (
          <div className="table-footer">
            <div className="table-info">
              Showing {data.length} of {noTicket} tickets • Page {page} of{" "}
              {Math.ceil(noTicket / limit)}
            </div>
            <div className="table-pagination">
              <Stack spacing={2}>
                <Pagination
                  count={Math.ceil(noTicket / limit)}
                  page={page}
                  onChange={handleChange}
                  color="primary"
                  shape="rounded"
                />
              </Stack>
            </div>
          </div>
        )}
      </div>

      <Modal
        size="lg"
        show={showMore}
        onHide={handleCloseMore}
        centered
        className="image-modal"
      >
        <Modal.Body className="p-0">
          <div className="image-modal-content">
            <div className="modal-header">
              <h6 className="modal-title">Image Preview</h6>
              <button className="close-btn" onClick={handleCloseMore}>
                <i className="fas fa-times"></i>
              </button>
            </div>
            <div className="modal-body">
              <img
                className="modal-image"
                src={activeImg}
                alt="Ticket attachment"
              />
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

const TicketTimer = ({ processingStartedAt }) => {
  const [timeLeft, setTimeLeft] = useState("");

  useEffect(() => {
    const interval = setInterval(() => {
      const startTime = new Date(processingStartedAt).getTime();
      const endTime = startTime + 48 * 60 * 60 * 1000; // 48 hours in ms
      const now = new Date().getTime();
      const remaining = endTime - now;

      if (remaining <= 0) {
        setTimeLeft("Exceeded");
        clearInterval(interval);
        return;
      }

      const hours = Math.floor(remaining / (1000 * 60 * 60));
      const minutes = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((remaining % (1000 * 60)) / 1000);

      setTimeLeft(`${hours}h ${minutes}m ${seconds}s`);
    }, 1000);

    return () => clearInterval(interval);
  }, [processingStartedAt]);

  return (
    <div
      className={`ticket-timer ${
        timeLeft === "Exceeded" ? "timer-exceeded" : "timer-normal"
      }`}
    >
      {timeLeft ? timeLeft : "-"}
    </div>
  );
};

export default AdminSupportTicket;
